import * as React from "react"
import { Box } from "@mui/material"
import { I18n } from "aws-amplify"
import { Authenticator } from "@aws-amplify/ui-react"
import { useRouter } from "next/router"

import { useAuth } from "context/auth.js"
import Logo from "components/Logo"
import { useClearQueryCache } from "hooks/useClearQueryCache"

I18n.putVocabulariesForLanguage("en", {
  "Sign in": "Log in", // Button label
  "Sign in to your account": "Welcome Back!",
  Username: "Email", // Username label
  Password: "Password", // Password label
  "Forgot your password? ": "Forgot your Password?",
  "Enter your username": "Enter your email",
})

const components = {
  Header() {
    return (
      <Box textAlign="center">
        <Logo simple />
      </Box>
    )
  },

  Footer() {
    return (
      <Box textAlign="center">
        <Box sx={{ color: "gray.400", fontSize: "sm" }}>
          &copy; Luz | All Rights Reserved
        </Box>
      </Box>
    )
  },

  SignIn: {
    Header() {
      return (
        <SlotHeader title="Sign in to your account">
          Pick up where you left off
        </SlotHeader>
      )
    },
  },
  ResetPassword: {
    Header() {
      return (
        <SlotHeader title="Reset your password">
          Passwords must be 8 chars
        </SlotHeader>
      )
    },
  },
  ForceNewPassword: {
    Header() {
      return (
        <SlotHeader title="ForceNewPassword">
          Passwords must be 8 chars
        </SlotHeader>
      )
    },
  },
}

function AuthPage() {
  const router = useRouter()
  const { user } = useAuth()
  const redirectTo = router?.query?.redirectTo
  const { clearQueryCache } = useClearQueryCache()

  if (user) {
    router.push(
      redirectTo?.startsWith("/dashboard") ? redirectTo : "/dashboard"
    )
  } else {
    // when unauthenticated users get here, clear the query cache
    clearQueryCache()
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      sx={{
        "& .amplify-heading": {
          textAlign: "center",
          fontSize: "3xl",
          fontWeight: 800,
          mt: 0,
          mb: 2,
        },
      }}
    >
      {/* Styling Amplify is a dumpster fire of problems, they use web components under the hood which make it impossible to target them unless you CSS vars, and you  */}
      <Authenticator
        usernameAlias="email"
        initialAuthState={router.query.type}
        components={components}
      >
        {() => (
          <Box
            sx={{
              display: "flex",
              flexDirection: "center",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Logo animate />
          </Box>
        )}
      </Authenticator>
    </Box>
  )
}

// Tell Next.js to export static files for each auth page
// See https://nextjs.org/docs/basic-features/data-fetching#getstaticpaths-static-generation
export const getStaticPaths = () => ({
  paths: [
    { params: { type: "signin" } },
    { params: { type: "signup" } },
    { params: { type: "forgotpassword" } },
    { params: { type: "resettingpassword" } },
  ],
  fallback: true,
})

export function getStaticProps() {
  return { props: {} }
}

export default AuthPage

function SlotHeader({ title, children }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        mt: 2,
      }}
    >
      <Box
        sx={{
          fontSize: "3xl",
          fontWeight: 900,
          color: "gray.800",
        }}
      >
        {title}
      </Box>
      {children && (
        <Box
          sx={{
            fontSize: "sm",
            color: "gray.500",
          }}
        >
          {children}
        </Box>
      )}
    </Box>
  )
}
